// PrivateShell.jsx
import { Navigate, Outlet } from "react-router-dom";
import Navbar from "../components/Navbar.jsx";

export default function PrivateShell({ usuario, onLogout }) {
  if (!usuario) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar usuario={usuario} onLogout={onLogout} />

      <main className="flex-1 px-4 py-4 overflow-visible">
        <div className="grid gap-4">
          <Outlet />
        </div>
      </main>
    </div>
  );
}